import { Box, Input, InputGroup, InputRightAddon } from '@chakra-ui/react'
import { memo, useCallback, useEffect, useState } from 'react'
import { FiSearch } from 'react-icons/fi'
import { useDebounce } from '../../../hooks/useDebounce'
import { normalizeString } from '../../../utils/normalizeString'

export const FilterImpression = memo(
  ({ impressions, setFilteredImpressions }) => {
    const [search, setSearch] = useState('')
    const debouncedSearch = useDebounce(search, 500)

    const filterImpressions = useCallback(() => {
      let initialImpressions = impressions

      if (debouncedSearch) {
        initialImpressions = impressions.filter((item) => {
          return normalizeString(item.descricao_impressao).includes(
            normalizeString(debouncedSearch)
          )
        })

        setFilteredImpressions(initialImpressions)
      }

      if (!debouncedSearch) {
        setFilteredImpressions(initialImpressions)
      }

      return initialImpressions
    }, [debouncedSearch, impressions, setFilteredImpressions])

    useEffect(() => {
      filterImpressions()
    }, [debouncedSearch, filterImpressions, impressions])

    return (
      <InputGroup mt="1rem" position="relative">
        <Input
          type="text"
          placeholder="O que você está cadastrando?"
          fontSize="1.2rem"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          borderRadius={0}
          borderTop={0}
          borderLeft={0}
          borderRight={0}
          _focus={{
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
          }}
          paddingBottom={'1rem'}
        />

        <Box position="absolute" right="0" top="0" height="100%">
          <InputRightAddon
            bg="transparent"
            border="none"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            paddingBottom={'1rem'}
          >
            <FiSearch size="1.5rem" color="#378BBF" />
          </InputRightAddon>
        </Box>
      </InputGroup>
    )
  }
)
